// HKDSE Type E (應用文) Q&A Data
// E1. 諸葛亮《出師表》

export const hkdseTypeEQAData = {
  'hkdse-e1-zhugeliang-chushibiao': {
    title: '諸葛亮《出師表》問答題精選',
    sections: {
      paragraphStructure: {
        title: '段落重點整理',
        content: [
          {
            subtitle: '第一段：形勢分析與忠臣之心',
            points: [
              {
                title: '內容重點',
                items: [
                  '先帝劉備創業未成而中途逝世，天下三分，益州疲弊，蜀國面臨危急存亡之秋。',
                  '然而內有忠臣、外有勇士，皆因追念先帝知遇之恩，願為後主效力。',
                  '強調「親賢遠佞」的重要，勉勵後主效法先帝，善用忠臣。'
                ]
              }
            ]
          },
          {
            subtitle: '第二段：治國方略與人才任用',
            points: [
              {
                title: '內容重點',
                items: [
                  '建議後主廣開言路，「宜開張聖聽」。',
                  '賞罰公平，內外一體，不偏私。',
                  '推薦郭攸之、費禕、董允等賢才，內政應多諮詢良臣，軍事則信任向寵。',
                  '強調「親賢遠佞」是國家興衰關鍵，援引西漢興隆、東漢衰亡作史例。'
                ]
              }
            ]
          },
          {
            subtitle: '第三段：自述生世與忠誠',
            points: [
              {
                title: '內容重點',
                items: [
                  '諸葛亮自述本為布衣，因先帝三顧草廬而感恩盡忠。',
                  '受任於敗軍之際，奉命於危難之間，常懼負託不效，「夙夜憂歎」。',
                  '南方已定，兵甲已足，今北伐是為報答先帝與忠於後主。',
                  '忠告後主，內政聽賢臣進言，國事有賴群策群力。'
                ]
              }
            ]
          },
          {
            subtitle: '第四段：臨別勸諫與深情流露',
            points: [
              {
                title: '內容重點',
                items: [
                  '臨行前懇切叮囑後主，如無成果，甘當受罪以告先帝在天之靈。',
                  '勸後主自行謀劃，多聽賢言，追念先帝遺詔。',
                  '文末「臨表涕零，不知所言」，情真意切，感人至深。'
                ]
              }
            ]
          }
        ]
      },
      centralTheme: {
        title: '中心思想',
        content: [
          '《出師表》以時局分析為開端，提出治國方略，勉勵後主廣納諫言、賞罰分明、親賢遠佞，表達自己報國盡忠、繼承先帝遺志、願為復興漢室鞠躬盡瘁的決心。'
        ]
      },
      selectedQuestions: {
        title: '問答題精選',
        questions: [
          {
            question: '文章的主旨及作者的心志是什麼？',
            answer: '《出師表》以時局分析為開端，提出治國方略，勉勵後主廣納諫言、賞罰分明、親賢遠佞，表達自己報國盡忠、繼承先帝遺志、願為復興漢室鞠躬盡瘁的決心。'
          },
          {
            question: '當時蜀漢的政治形勢如何？有何危險？',
            answer: '先帝早逝，天下三分，益州疲弊，國勢危急。內部需團結忠臣，外部需抵抗強敵，如不謹慎用人、廣納賢言，則國家難保。'
          },
          {
            question: '諸葛亮為何勸後主「宜開張聖聽，不宜妄自菲薄」？',
            answer: '因為國家危急，唯有廣開言路，才能集思廣益，挽救時局。若自卑自限、阻塞諫言，則忠良之路受阻，國事益危。'
          },
          {
            question: '文中舉出哪些賢臣？作者對他們有何建議？',
            answer: '郭攸之、費禕、董允等皆為忠良之臣，建議後主內政凡事多諮詢他們，軍事則重用向寵，可補過失、廣益國政。'
          },
          {
            question: '諸葛亮自述出身寒微、受知遇之恩，有何用意？',
            answer: '一方面表明感恩圖報、忠誠不渝之志，另一方面以此打動後主，增強勸諫的說服力，使其願意接納忠言。'
          },
          {
            question: '文章中如何運用史例及對比論證？請舉例說明。',
            answer: '以「親賢臣，遠小人，此先漢所以興隆也；親小人，遠賢臣，此後漢所以傾頹也」對比西漢與東漢的用人之策，突顯國家興亡關鍵。'
          },
          {
            question: '為何諸葛亮用語如父子之間般語重心長地勸諫後主？',
            answer: '因劉備臨終托孤，諸葛亮如父兄般照顧後主，責任重大，語氣懇切誠懇，望其謹記父志，親賢遠佞，復興漢室。'
          },
          {
            question: '文章最後「臨表涕零，不知所言」有何作用？',
            answer: '表現作者臨別依依不捨、憂國憂民、忠心耿耿的情懷，感情真摯，極具感染力，令人動容。'
          }
        ]
      }
    }
  }
};

export const getTypeEQAByTextId = (textId) => {
  return hkdseTypeEQAData[textId] || null;
}; 